import { Globals } from "../../global/Globals";

export const getFilteredHeaders = (data, form) => {
    if (!Array.isArray(data) || data.length === 0) return [];
  
    return Object.keys(data[0]).filter((item) => {
      return (
        item !== "proposalId" &&
        item !== "producerId" &&
        item !== "producerI" &&
        item !== "proposalDetails" &&
        // item !== "genre" &&
        // item !== "email" &&
        item !== "clusterId" &&
        item !== "userId" &&
        item !== "location" &&
        item !== "proposalDetailId"&&
        item !== 'employeeId' &&
        !(form === "internalDashboard" && item === "genreName") &&
        !(form === "myProposals" && item === "genre") // 👈 condition fo
      );
    });
  };

  export const ignoreHeaders = (data) => {
    if (!Array.isArray(data) || data.length === 0) return [];
  
    return Object.keys(data[0]).filter((item) => {
      return (
        item !== "proposalId" &&
        item !== "producerId" &&
        item !== "producerI" &&
        item !== "proposalDetails" &&
        item !== "clusterId" &&
        item !== "userId" &&
        item !== "location" &&
        item !== "proposalDetailId"&&
        item !== 'employeeId' &&
        item !== 'proposalType' &&
        item !== 'reAssignedCluster' &&
        item !== 'reAssignedChannel'
      );
    });
  };


  export const formatClusterName =(clusternames)=>{
    return clusternames.join(", ");
  }

  export const displayGenres = (genres) => {
    if (!genres || genres.length === 0) return '';
    if (genres.length === 1) return genres[0];
    return `${genres[0]} + ${genres.length - 1}`;
  };

  
    export const formatProposalStatusImg =(status) =>{
      const title = status ? (status.toUpperCase()).replace(/[- ]/g, '') : status;
      const proposalStatusImg = Globals.IMG[title] ? Globals.IMG[title] : status;
      return proposalStatusImg;
    }

    
  export const formatProposalStatus =(status) =>{
    const formattedstatus = status? status.replace(/[- ]/g, '') : status;
    return formattedstatus?.toUpperCase();
  }

  export const proposols_type = (type) => {
    const Proposal_Type = Globals.PROPOSALS_TYPE[type];
    return Proposal_Type;
  };

  export const formatStatus = (statusData) => {
    const Title = Globals.TABLE_STATUS[statusData];
    return Title;
  };

  export const statusImg = (statusCode) => {
    const Title = Globals.TABLE_STATUS[statusCode];
    const title = (Title.toUpperCase())?.replace(/[- ]/g, '');
    const statusImg = Globals.IMG[title];
    return statusImg;
  };
  